import CryptoJS from 'crypto-js';

class CryptoService {
  constructor() {
    const keyString = import.meta.env.VITE_ENCRYPTION_KEY || 
                     'cC_Rr-mMInItInitCRM@InITsoLUtIOnS123456';
    const ivString = import.meta.env.VITE_ENCRYPTION_IV || 
                    'InitSoulutions1234';
    
    // Use exact bytes as .NET - UTF8 encoding
    this.key = this.stringToCryptoJSKey(keyString, 32);
    this.iv = this.stringToCryptoJSKey(ivString, 16);
    
   
  }

  // Convert string to CryptoJS WordArray matching .NET's UTF8 encoding
  stringToCryptoJSKey(str, requiredBytes) {
    // Convert to UTF8 bytes
    const utf8Bytes = this.stringToUtf8Bytes(str);
    const resultBytes = new Uint8Array(requiredBytes);
    
    if (utf8Bytes.length >= requiredBytes) {
      // Truncate if longer
      resultBytes.set(utf8Bytes.slice(0, requiredBytes));
    } else {
      // Pad if shorter (matching .NET logic)
      resultBytes.set(utf8Bytes);
      for (let i = utf8Bytes.length; i < requiredBytes; i++) {
        // .NET pattern: for key: (byte)(i % 256)
        // for IV: (byte)((i + 1) % 256)
        if (requiredBytes === 32) {
          // Key padding
          resultBytes[i] = i % 256;
        } else {
          // IV padding
          resultBytes[i] = (i + 1) % 256;
        }
      }
    }
    
    return CryptoJS.lib.WordArray.create(resultBytes);
  }

  stringToUtf8Bytes(str) {
    return new TextEncoder().encode(str);
  }

  // Simplified encrypt method
  encrypt(plainText) {
    try {
      
      // Convert plain text to WordArray
      const plainTextWordArray = CryptoJS.enc.Utf8.parse(plainText);
      
      // Encrypt with CBC mode and PKCS7 padding
      const encrypted = CryptoJS.AES.encrypt(plainTextWordArray, this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      
      // Get ciphertext as Base64
      const cipherText = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      
      return cipherText;
    } catch (error) {
      console.error('Encryption error:', error);
      throw error;
    }
  }

  // Simplified decrypt method
  decrypt(encryptedBase64) {
    try {
      
      // Parse Base64
      const cipherText = CryptoJS.enc.Base64.parse(encryptedBase64);
      
      // Decrypt
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: cipherText },
        this.key,
        {
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      
      // Convert to UTF8 string
      const result = decrypted.toString(CryptoJS.enc.Utf8);
      
      if (!result) {
        throw new Error('Decryption returned empty result');
      }
      
      return result;
    } catch (error) {
      console.error('Decryption error:', error);
      console.error('Input was:', encryptedBase64.substring(0, 100) + '...');
      throw error;
    }
  }

  // Process API response - handle both wrapped and direct encrypted data
  processApiResponse(responseData) {
    
    if (!responseData) return responseData;
    
    // If response has data field, it's wrapped encrypted data
    if (responseData.data && typeof responseData.data === 'string') {
      try {
        const decrypted = this.decrypt(responseData.data);
        const parsed = JSON.parse(decrypted);
        return parsed;
      } catch (error) {
        console.error('Failed to process wrapped encrypted response:', error);
        return responseData;
      }
    }
    
    // If response is a string, it might be direct encrypted
    if (typeof responseData === 'string') {
      try {
        const decrypted = this.decrypt(responseData);
        const parsed = JSON.parse(decrypted);
        return parsed;
      } catch (error) {
        console.error('Failed to process direct encrypted response:', error);
        return responseData;
      }
    }
    
    // Return as-is if not encrypted
    return responseData;
  }
}

export const cryptoService = new CryptoService();